package gr.tech.GRAttestation.models.activity

import kotlinx.serialization.Serializable

@Serializable
data class ActivityDTO(
    val id: Int,
    val userUUID: String? = null,
    val userIdentity: String,
    val activity: String,
    val createdAt: String,
    val userAgent: String,
    val ipAddress: String,
    val storeId: Int? = null,
    val formId: Int? = null,
    val skuId: Int? = null,
)
